import type { DSMenuProps } from "@/src/design_system/navigations/menu/types";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

export const DS_MENU_CLASSES = {
  Root: "ds-menu",
  SizeSmall: "ds-menu--sm",
  SizeMedium: "ds-menu--md",
  SizeLarge: "ds-menu--lg",
  Entry: "ds-menu__entry",
  Item: "ds-menu__item",
  ItemDefault: "ds-menu__item--default",
  ItemDanger: "ds-menu__item--danger",
  ItemContent: "ds-menu__item-content",
  Icon: "ds-menu__icon",
  Text: "ds-menu__text",
  Title: "ds-menu__title",
  Subtitle: "ds-menu__subtitle",
  Suffix: "ds-menu__suffix",
  Prefix: "ds-menu__prefix",
  SubmenuTrigger: "ds-menu__submenu-trigger",
  Hierarchy: "ds-menu__hierarchy",
  Separator: "ds-menu__separator",
  SeparatorLabelled: "ds-menu__separator--labelled",
  SeparatorLabel: "ds-menu__separator-label",
  SeparatorLine: "ds-menu__separator-line",
} as const;

export const DS_MENU_SIZE_TO_CLASS_MAP: Record<NonNullable<DSMenuProps["size"]>, string> = {
  [DS_SIZE.Small]: DS_MENU_CLASSES.SizeSmall,
  [DS_SIZE.Medium]: DS_MENU_CLASSES.SizeMedium,
  [DS_SIZE.Large]: DS_MENU_CLASSES.SizeLarge,
} as const;
